import React from "react"

// expected: "fi" | "en", but accept any string safely
type LanguageCode = "fi" | "en" | string

type TextEntry = {
  text?: string
}

type TextBlockData = Record<LanguageCode, TextEntry | undefined>

type GuideTextProps = {
  data: TextBlockData
  language: LanguageCode
  type: "header" | "paragraph" | string
}

const isEmpty = (value: string | undefined | null): boolean => {
  return !value || value.trim() === ""
}

const resolveContent = (data: TextBlockData, language: LanguageCode): string => {
  // normalize language to supported keys when possible, with safe fallbacks
  const normalizedLang: LanguageCode = language === "fi" || language === "en" ? language : "en"

  const fromPreferred = data?.[normalizedLang]?.text
  const fallback = data?.text

  const candidate = fromPreferred ?? fallback
  return typeof candidate === "string" ? candidate : ""
}

export const GuideTextPreview: React.FC<GuideTextProps> = ({ data, language, type }) => {
  const content = resolveContent(data, language)
  const classes = type === "header" ? "tw-text-sm tw-font-bold tw-m-0" : "tw-text-sm tw-whitespace-pre-wrap tw-m-0"

  if (isEmpty(content)) {
    return null
  }

  return <div className="text-container preview">{!isEmpty(content) && <p className={classes}>{content}</p>}</div>
}

export const GuideTextList: React.FC<GuideTextProps> = ({ data, language, type }) => {
  const content = resolveContent(data, language)
  const classes =
    type === "header"
      ? "tw-text-sm tw-mb-1 tw-font-bold tw-truncate"
      : "tw-text-sm tw-whitespace-pre-wrap tw-line-clamp-3"

  return <div className="text-container list">{!isEmpty(content) && <p className={classes}>{content}</p>}</div>
}
